import { ChangeDetectionStrategy, Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import {
    IOnboardingSyncCondition,
    ISyncOnboardingEditItem,
    ISyncOnboarding,
    IOnboardingEditItem,
} from '../../fi-onboarding';
import { isDefined } from '@fi-shared/utils';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { FiConditionalLogicConditionEditorDialogComponent } from './fi-condition-editor-dialog/fi-condition-editor-dialog.component';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Component({
    selector: 'fi-onboarding-connect-edit-conditional-logic-tab',
    templateUrl: './fi-conditional-logic-tab.component.html',
    styleUrls: ['./fi-conditional-logic-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-conditional-logic-tab' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiConditionalLogicTabComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiConditionalLogicTabComponent,
            multi: true,
        },
    ],
})
export class FiConditionalLogicTabComponent extends ControlValueAccessorValidatorBase<ISyncOnboardingEditItem> {
    @Input() selectedOnboardings: IOnboardingEditItem[] = [];
    private readonly fiDialogsService: FiDialogsService = inject(FiDialogsService);
    private readonly appTextService: AppTextService = inject(AppTextService);

    protected openConditionEditorDialog(conditionIndex?: number): void {
        let condition = undefined;
        if (!isDefined(conditionIndex)) {
            condition = this.getNewCondition();
        } else {
            condition = this.ngModel.Conditions[conditionIndex];
        }

        this.fiDialogsService
            .custom({
                contentComponentRef: FiConditionalLogicConditionEditorDialogComponent,
                contentComponentData: {
                    condition,
                    selectedOnboardings: this.selectedOnboardings,
                },
                headerText: this.appTextService.get('conditional_logic.condition_editor'),
            })
            .onYesButtonClick((resultCondition: IOnboardingSyncCondition) => {
                if (!isDefined(conditionIndex)) {
                    this.ngModel.Conditions.push(resultCondition);
                } else {
                    this.ngModel.Conditions.splice(conditionIndex, 1, resultCondition);
                }
                this.doPropagateChanges();
            });
    }

    protected deleteCondition(conditionIndex: number): void {
        this.ngModel.Conditions.splice(conditionIndex, 1);
        this.doPropagateChanges();
    }

    protected logger(): void {}

    private getNewCondition(): IOnboardingSyncCondition {
        return {
            //SourceOnboardingId: undefined,
            SourceOnboardingStepId: undefined,
            SourceOnboardingStepCondition: undefined,
            //TargetOnboardingId: undefined,
            TargetOnboardingStepId: undefined,
            TargetOnboardingStepAction: undefined,
        };
    }
}
